var render = function render(){var _vm=this,_c=_vm._self._c;return (false)?_c('div',{staticClass:"topbar_container"},[_c('van-nav-bar',{attrs:{"title":_vm.title,"left-arrow":_vm.leftArrow,"safe-area-inset-top":true,"placeholder":true},on:{"click-left":_vm.onClickLeft},scopedSlots:_vm._u([{key:"right",fn:function(){return [_vm._t("right")]},proxy:true}],null,true)})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }